function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import mobile from 'is-mobile';
import { Button } from 'module-tsl-ui-elements';
import RelatedResourceList from './RelatedResourceList';
import { emitResourceDisplayModal, emitRelatedResourcesDisplay, emitRecommendedResourcesDisplay } from '../utils/MzHelper';

var PaymentSuccess = /*#__PURE__*/function (_Component) {
  _inherits(PaymentSuccess, _Component);

  var _super = _createSuper(PaymentSuccess);

  _createClass(PaymentSuccess, null, [{
    key: "checkEbookDate",
    value: function checkEbookDate() {
      return +new Date() > 1537142400000 && +new Date() < 1538524799000; // Start 00.00 BST 17 September 2018, end 23.59 BST 2 October 2018
    }
  }]);

  function PaymentSuccess(props) {
    var _this;

    _classCallCheck(this, PaymentSuccess);

    _this = _super.call(this, props);

    if (!props.recommendedResourcesTimeout.timeoutError && props.recommendedResources.length && props.experimentVariant) {
      var MAX_RECOMMENDATIONS = 4;

      var paidRecommendedResources = _this.props.recommendedResources.filter(function (resource) {
        return !!resource.formattedPrice;
      }).slice(0, MAX_RECOMMENDATIONS);

      emitRecommendedResourcesDisplay(global, 'post-payment-recommended', paidRecommendedResources);
    }

    return _this;
  }

  _createClass(PaymentSuccess, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.relatedResources.length === 0 && !this.props.loadingRelated) {
        // TODO does the /api/search/v4/recommend api take multiple resourceId?
        // for now take recommendations from first item in list
        this.props.loadRelatedResources(this.props.resourceIds[0], 'purchase');
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (global.TES && global.TES.events) {
        global.TES.events.trigger('payment:success');
      }

      if (this.props.resourceIds.length === 1 && this.requiredFieldsForSingleResource()) {
        if (!this.props.isBundleSale) {
          if (!mobile() && this.props.hasDownloadBundle) {
            global.window.location.href = "/teaching-resource/download/".concat(this.props.resourceIds[0], "/bundle");
          } else if (!this.props.hasDownloadBundle && this.props.fileAttachmentCount !== 1) {
            // interactives (no attachment) or no zip file was created (special cases where too many files in the resource causing the zipping service to fail, need to download each individually).
            var url = global.window.location.href;

            if (url.indexOf('#') !== -1) {
              url = url.substring(0, url.indexOf('#'));
            }

            global.window.location.href = "".concat(url, "#files");
          } else if (!mobile() && this.props.fileAttachmentCount === 1) {// no zip created, however, a single file to download
            // TODO: endpoint should handle redirection to referer?
            // global.window.location.href = this.getDownloadSingleResourceUrl(); // >>>>> UN-COMMENT THIS LINE <<<<<< //
          }
        }
      }

      emitResourceDisplayModal(global, 'post-purchase-modal');
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ((!this.props.relatedResources || !this.props.relatedResources.length) && nextProps.relatedResources.length && !this.props.experimentVariant) {
        emitRelatedResourcesDisplay(global, 'post-payment-related', nextProps.relatedResources);
      }
    }
  }, {
    key: "initiateDownloadfromIframes",
    value: function initiateDownloadfromIframes() {
      var resourceIds = this.props.bundledResourcesIds;
      resourceIds.forEach(function (id) {
        var iframe = document.createElement('iframe');
        iframe.src = "/teaching-resource/download/".concat(id, "/bundle");
        iframe.id = "iframe-download-".concat(id);
        iframe.width = 0;
        document.body.appendChild(iframe);
        return;
      });
    }
  }, {
    key: "getDownloadSingleResourceUrl",
    value: function getDownloadSingleResourceUrl() {
      var currentUrl = "/teaching-resource/-".concat(encodeURIComponent(this.props.resourceIds[0]));

      if (global.location) {
        currentUrl = global.location.href; // TODO: Move to settings
      }

      var downloadUrl = "/teaching-resource/download/".concat(encodeURIComponent(this.props.resourceIds[0]), "/attachment?attachmentId=").concat(encodeURIComponent(this.props.singleAttachment && this.props.singleAttachment.id), "&pageUrl=").concat(encodeURIComponent(currentUrl));
      return downloadUrl;
    }
  }, {
    key: "requiredFieldsForSingleResource",
    value: function requiredFieldsForSingleResource() {
      if ('title' in this.props && 'isBundleSale' in this.props && 'hasDownloadBundle' in this.props && 'hasDownloadBundle' in this.props && 'fileAttachmentCount' in this.props && 'singleAttachment' in this.props) {
        return true;
      }

      console.error('Failed to provide all required props for single resource'); // eslint-disable-line no-console

      return false;
    }
  }, {
    key: "renderRelatedResources",
    value: function renderRelatedResources() {
      var html;

      if (this.props.relatedResourcesTimeout && this.props.relatedResourcesTimeout.timeoutError) {
        html = /*#__PURE__*/React.createElement("div", {
          className: "serviceUnavailableError"
        }, this.props.relatedResourcesTimeout.message);
      } else if (this.props.relatedResourceFailed) {
        html = '';
      } else if (this.props.relatedResources.length === 0 && this.props.loadingRelated) {
        // put a spinner while loading related resources
        html = /*#__PURE__*/React.createElement("span", {
          className: "icon-text-container"
        }, /*#__PURE__*/React.createElement("i", {
          className: "icon-spinner icon-spin"
        }), "Loading...");
      } else if (this.props.relatedResources.length > 0) {
        // regular UI of related resources
        html = /*#__PURE__*/React.createElement(RelatedResourceList, {
          title: "Recommended for you",
          resources: this.props.relatedResources,
          isLazyLoaded: false,
          mzData: {
            module: 'post-purchase-modal',
            event_title: 'resource-cards'
          }
        });
      }

      return html;
    }
  }, {
    key: "renderRecommendedResources",
    value: function renderRecommendedResources() {
      var MAX_RECOMMENDATIONS = 4;
      var html;

      if (this.props.recommendedResources && this.props.recommendedResources.length === 0) {
        // then render related resources
        html = this.renderRelatedResources();
      } else if (this.props.recommendedResourcesTimeout && this.props.recommendedResourcesTimeout.timeoutError) {
        html = /*#__PURE__*/React.createElement("div", {
          className: "serviceUnavailableError"
        }, this.props.recommendedResourcesTimeout.message);
      } else if (this.props.recommendedResources) {
        var newRecommendedResources = this.props.recommendedResources.filter(function (resource) {
          return !!resource.formattedPrice;
        }).slice(0, MAX_RECOMMENDATIONS);

        if (newRecommendedResources.length < 4 && this.props.relatedResources.length > 0) {
          // possible for recommended resources not to have enough resources to recommend, especially if the purchased resource is new
          newRecommendedResources = newRecommendedResources.concat(this.props.relatedResources).slice(0, MAX_RECOMMENDATIONS);
        } // show recommended resources


        html = /*#__PURE__*/React.createElement(RelatedResourceList, {
          title: "You might also like...",
          resources: newRecommendedResources,
          isLazyLoaded: false,
          mzData: {
            module: 'post-purchase-modal-recommended',
            event_title: 'resource-cards'
          }
        });
      }

      return html;
    }
  }, {
    key: "renderMarketingSlot",
    value: function renderMarketingSlot() {
      if (!this.props.relatedResources.length || this.props.relatedResourceFailed) {
        return /*#__PURE__*/React.createElement("div", {
          "data-x-marketing-slot": "Post Purchase Promo",
          className: "p-2"
        });
      }

      return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", {
        "data-x-marketing-slot": "Post Purchase Promo",
        className: "payment-success__marketing-slot"
      }), /*#__PURE__*/React.createElement("div", {
        className: "payment-success__recommended-resources"
      }, this.props.experimentVariant ? this.renderRecommendedResources() : this.renderRelatedResources()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var subtitleText;

      if (this.props.resourceIds.length === 1 && this.requiredFieldsForSingleResource()) {
        // render payment success for 1 resource like in the RDP
        if (!this.props.isBundleSale) {
          // not a bundle
          if (mobile()) {
            subtitleText = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
              className: "heading heading--md heading--medium margin-bottom-md"
            }, "for your purchase of ", /*#__PURE__*/React.createElement("span", {
              className: "text text--medium"
            }, "\"", this.props.title, "\""), " from ", /*#__PURE__*/React.createElement("a", {
              className: "link link--colored",
              href: "/teaching-resources/shop/".concat(this.props.resourceAuthorUsername)
            }, this.props.resourceAuthorUsername)), /*#__PURE__*/React.createElement("div", {
              className: "text-center margin-top-bottom-lg"
            }, /*#__PURE__*/React.createElement("a", {
              className: "tds-btn tds-btn--primary tds-btn--lg",
              href: this.getDownloadSingleResourceUrl()
            }, "Download Now")), /*#__PURE__*/React.createElement("p", {
              className: "text text--italic text--sm"
            }, "If you want to download this resource at a later time, you can do so direct from ", /*#__PURE__*/React.createElement("a", {
              className: "link link--colored",
              "data-mz": true,
              "data-module": "post-purchase-modal",
              "data-id": "post-purchase-modal-btn",
              "data-event_title": "my-downloads",
              href: "/my-resources/downloads"
            }, "your dashboard")));
          } else {
            subtitleText = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
              className: "heading heading--md heading--medium margin-bottom-md"
            }, /*#__PURE__*/React.createElement("span", {
              className: "text text--medium"
            }, this.props.title), " should now be downloading."), /*#__PURE__*/React.createElement("p", {
              className: "text"
            }, "You can redownload this resource any time from your ", /*#__PURE__*/React.createElement("a", {
              className: "link link--colored",
              "data-mz": true,
              "data-module": "post-purchase-modal",
              "data-id": "post-purchase-modal-btn",
              "data-event_title": "my-downloads",
              href: "/my-resources/downloads"
            }, "resources dashboard"), "."));
          }

          if (!this.props.hasDownloadBundle && this.props.fileAttachmentCount !== 1) {
            // interactives only (no attachment) or no zip file was created (special cases where too many files in the resource causing the zipping service to fail, need to download each individually).
            var url = global.window.location.href;

            if (url.indexOf('#') !== -1) {
              url = url.substring(0, url.indexOf('#'));
            }

            url = "".concat(url, "#files");
            subtitleText = /*#__PURE__*/React.createElement("span", {
              className: "text"
            }, "These files will not download automatically. Go to the ", /*#__PURE__*/React.createElement("a", {
              className: "link link--colored",
              href: url,
              onClick: function onClick() {
                return _this2.onCloseModal();
              }
            }, "Files included"), " tab to access the files for ", /*#__PURE__*/React.createElement("span", {
              className: "text text--medium"
            }, this.props.title), ".");
          }
        } else {
          // RDP bundle, point user to Resources included section of the RDP
          var _url = global.window.location.href;

          if (_url.indexOf('#') !== -1) {
            _url = _url.substring(0, _url.indexOf('#'));
          }

          _url = "".concat(_url, "#files");
          subtitleText = /*#__PURE__*/React.createElement("span", {
            className: "text"
          }, /*#__PURE__*/React.createElement("button", {
            "class": "tds-btn tds-btn--md tds-btn--primary",
            onClick: function onClick() {
              return _this2.initiateDownloadfromIframes();
            }
          }, "Download All Resources"), /*#__PURE__*/React.createElement("p", {
            className: "text pt1 margin-top-md"
          }, "To pick and choose which files to download:", /*#__PURE__*/React.createElement("br", null), "Navigate to the ", /*#__PURE__*/React.createElement("a", {
            className: "link link--colored",
            href: _url,
            onClick: function onClick() {
              return _this2.onCloseModal();
            }
          }, "Resources included"), " section to download each file individually."));
        }
      } else {
        // multi-buy design
        var resourceText = ' resources have ';

        if (this.props.resourceIds.length === 1) {
          resourceText = ' resource has ';
        }

        subtitleText = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
          className: "text"
        }, "Your ", resourceText, " been successfully purchased and added to ", /*#__PURE__*/React.createElement("a", {
          className: "link link--colored",
          "data-mz": true,
          "data-module": "post-purchase-modal",
          "data-id": "post-purchase-modal-btn",
          "data-event_title": "my-buyer-dashboard",
          href: "/my-resources/",
          onClick: function onClick() {
            return _this2.onCloseModal();
          }
        }, "My resources")), /*#__PURE__*/React.createElement(Button, {
          href: "/my-resources/",
          theme: "secondary",
          onClick: function onClick() {
            return _this2.onCloseModal();
          }
        }, "Take me there!"));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-center pt-1"
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon icon-tds-checked-1 icon-green icon--unit-xxl"
      }), /*#__PURE__*/React.createElement("h2", {
        className: "heading heading--xl heading--medium margin-bottom-md"
      }, "Thank you, ", this.props.userName), /*#__PURE__*/React.createElement("p", {
        className: "text"
      }, subtitleText)), this.renderMarketingSlot());
    }
  }]);

  return PaymentSuccess;
}(Component);

PaymentSuccess.displayName = "PaymentSuccess";
export { PaymentSuccess as default };
PaymentSuccess.defaultProps = {
  title: '',
  hasDownloadBundle: false,
  isBundleSale: false,
  relatedResourcesTimeout: {},
  fileAttachmentCount: 0,
  singleAttachment: {
    id: ''
  },
  price: {
    amount: 1,
    code: '',
    credits: 0,
    discountBy: '',
    discountPercentage: 0,
    isDiscounted: false,
    originalPrice: '',
    price: '',
    subMultiple: 1,
    symbol: '£',
    discounts: {}
  },
  experimentVariant: false,
  recommendedResourcesTimeout: {}
};
PaymentSuccess.propTypes = {
  bundledResourcesIds: PropTypes.array,
  title: PropTypes.string,
  hasDownloadBundle: PropTypes.bool,
  isBundleSale: PropTypes.bool,
  resourceIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  resourceAuthorUsername: PropTypes.string.isRequired,
  loadRelatedResources: PropTypes.func.isRequired,
  loadingRelated: PropTypes.bool.isRequired,
  relatedResourcesTimeout: PropTypes.object,
  relatedResourceFailed: PropTypes.bool.isRequired,
  relatedResources: PropTypes.arrayOf(PropTypes.object).isRequired,
  fileAttachmentCount: PropTypes.number,
  singleAttachment: PropTypes.shape({
    id: PropTypes.string.isRequired
  }),
  experimentVariant: PropTypes.bool,
  recommendedResources: PropTypes.arrayOf(PropTypes.object).isRequired,
  recommendedResourcesTimeout: PropTypes.object,
  userName: PropTypes.string.isRequired
};